import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-16">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <XCircle size={72} weight="duotone" className="text-[#4A6E7C] mx-auto mb-6" />
        <h1 className="font-display text-4xl font-bold">Checkout cancelled</h1>
        <p className="text-[#63675E] mt-3">No charge was made. Your cart is saved for whenever you're ready.</p>
        <Link to="/cart"><Button className="rounded-full bg-[#2E523A] hover:bg-[#26442f] mt-8">Return to cart</Button></Link>
      </div>
    </div>
  );
}
